import React from "react";
import Heading from "../../elements/heading";
import PrimaryLink from "../../elements/primary-link";
import PropTypes from "prop-types";
import InfoBlock from "../../elements/info-block";
import { RichText } from "@sitecore-jss/sitecore-jss-react";

const MembershipInfoBlock = ({
  infoHeadingType,
  infoHeadingBody,
  infoBody,
  button,
  infoTitle
}) => {
  return (
    <InfoBlock>
      <Heading
        type={{ fields: { phrase: { value: "h3" } } }}
        className="title show-on-scroll"
        html={infoTitle}
        typographyClass="type-h3"
      />
      <Heading
        type={infoHeadingType}
        className="title show-on-scroll"
        html={infoHeadingBody}
        typographyClass="type-h2"
      />
      {infoBody?.value && (
        <RichText className="body-text" tag="div" field={infoBody} />
      )}

      {button && <PrimaryLink {...button} />}
    </InfoBlock>
  );
};

MembershipInfoBlock.propTypes = {
  title: PropTypes.string,
  heading: PropTypes.object,
  body: PropTypes.string,
  button: PropTypes.object
};

export default MembershipInfoBlock;
